//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Workflow Type Guids */
export const WorkflowType = {
    /** The Protect My Ministry workflow action. */
    Protectmyministry: "16D12EF7-C546-4039-9036-B73D118EDC90",
    /** The Request Assessment Workflow Type */
    RequestAssessment: "31DDC001-C91A-4418-B375-CAB1475F7A62",
    /** Unattended Checkin Workflow Type */
    UnattendedCheckin: "011E9F5A-60D4-4FF5-912A-290881E37EAF",
};
